import { render, staticRenderFns } from "./ShopifyMoney.vue?vue&type=template&id=00976a83&"
import script from "./ShopifyMoney.vue?vue&type=script&lang=js&"
export * from "./ShopifyMoney.vue?vue&type=script&lang=js&"
import style0 from "./ShopifyMoney.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports